// eslint-disable-next-line no-unused-vars

// Libraries
import { useEffect, createRef } from "react";
import { useDispatch, useSelector } from "react-redux";

// Layout
import DashboardLayout from "layouts/DashboardLayout";

// Custom Components
import DashboardNavbar from "components/DashboardNavbar";
import Footer from "components/Footer";
import MDBox from "components/MDBox";
import MaterialTablePicker from "components/MaterialTablePicker";

// Material UI components
import Grid from "@mui/material/Grid2";

// Redux Actions

import setAlert from "store/actions/alertActions";
import { getPdf, getCsv } from "store/actions/exportAction";
import { updateVenue, clearErrors, deleteVenue } from "store/actions/venuesActions";
import columnsMap from "components/MaterialTablePicker/TableColumns";

const AllVenues = () => {
  const tableRef = createRef();
  const dispatch = useDispatch();

  const loading = useSelector((state) => state.venues.loading);
  const error = useSelector((state) => state.venues.error);
  const user = useSelector((state) => state.users.user);
  useEffect(() => {
    if (error) {
      dispatch(setAlert(error, "error"));
      dispatch(clearErrors());
    }
  }, [error, setAlert]);

  const deleteVenueFn = (id) => {
    dispatch(deleteVenue(id));
  };

  const updateVenueFn = (data) => {
    const updatedData = {
      _id: data._id,
      title: data.title,
      top: data.top,
      fomoMessage: data.fomoMessage,
    };
    dispatch(updateVenue(updatedData));
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container spacing={3} pt={3}>
        <Grid size={{ xs: 12 }}>
          <MDBox>
            <MaterialTablePicker
              screen="VenuesList"
              title="Venues"
              searchField="venues"
              extraFields="fomoMessage"
              exportMenuField="venues"
              onRowClickURL="/admin/venues"
              currentUrl="venues"
              tableRef={tableRef}
              columns={[
                columnsMap.titleCol,
                columnsMap.primaryDestinationName,
                columnsMap.productCount,
                columnsMap.top,
              ]}
              asyncTable
              asyncURL={`${process.env.REACT_APP_API}/venues?`}
              isLoading={loading}
              filteringOptions={false}
              addUrl="venues/new-venue"
              actionsName="Venue"
              editableUpdate={updateVenueFn}
              editableDelete={deleteVenueFn}
              updateRoleAction
              deleteRoleAction
              editableRole={user?.role === "admin"}
              actionsRole={user?.role === "admin"}
              getPdf={(value, query) => {
                if (value) {
                  if (user?.role === "partner") {
                    dispatch(
                      getPdf(
                        value,
                        `stats/pdf${query}&fields=title,primaryDestinationName,productCount,top`,
                        "Venues"
                      )
                    );
                  } else {
                    dispatch(
                      getPdf(
                        value,
                        `stats/pdf${query}&fields=title,primaryDestinationName,productCount,top`,
                        "Venues"
                      )
                    );
                  }
                } else {
                  // Handle the case where 'value' is undefined or empty
                  console.error("Error: No data for PDF export.");
                }
              }}
              getCsv={(query) => {
                if (user?.role === "partner") {
                  dispatch(
                    getCsv(
                      `stats/csv?${query}&fields=title,primaryDestinationName,productCount,top`,
                      "Venues"
                    )
                  );
                } else if (user?.role === "admin") {
                  dispatch(
                    getCsv(
                      `stats/csv${query}&fields=title,primaryDestinationName,productCount,top`,
                      "Venues"
                    )
                  );
                } else {
                  // Handle the case where 'value' is undefined or empty
                  console.error("Error: No data for CSV export.");
                }
              }}
            />
          </MDBox>
        </Grid>
      </Grid>
      <Footer />
    </DashboardLayout>
  );
};

export default AllVenues;
